import { PageHero, CtaBlock, FaqList } from "@/components/site/Ui";
import Plans from "@/components/site/Plans";
import { useSeo } from "@/lib/seo";

const qa = [
  { q: "Le devis est-il gratuit ?", a: "Oui. Après un premier échange, je vous envoie un devis détaillé adapté à votre commerce, sans engagement." },
  { q: "Pourquoi « à partir de » ?", a: "Le prix dépend du nombre de pages, des langues, des fonctionnalités (réservation, arrhes, cartes cadeaux) et des contenus à créer." },
  { q: "Puis-je commencer petit ?", a: "Oui. On peut démarrer avec l'Essentiel ou la Visibilité locale, puis ajouter la réservation plus tard." },
];

export default function Tarifs() {
  useSeo({
    title: "Tarifs — création de site et visibilité locale à Toulouse",
    description: "Tarifs indicatifs : site vitrine dès 990 €, site avec réservation dès 1 890 €, visibilité locale dès 390 €, hébergement et suivi dès 39 €/mois. Devis gratuit.",
    path: "/tarifs",
  });
  return (
    <>
      <PageHero testid="tarifs-hero" label="Tarifs" lines={["Des formules simples,", "un devis sur mesure."]} intro="Quatre points de départ. Je les ajuste à votre commerce lors de notre échange." />
      <section className="wrap pb-20"><Plans dark={false} /><p className="mt-8 border-t border-ink/20 pt-6 text-[17px] font-medium" data-testid="tarif-identite">Identité & visuels de marque : sur devis.</p></section>
      <section className="wrap grid gap-10 border-t border-ink/20 py-16 md:py-24 lg:grid-cols-12">
        <h2 className="display h-md lg:col-span-4">Questions sur les tarifs</h2>
        <div className="lg:col-span-7 lg:col-start-6"><FaqList items={qa} /></div>
      </section>
      <CtaBlock />
    </>
  );
}
